import { EnumMapper } from 'modules/campaigns/editor/components/constants';
import {
  MetaApprovalStatusDefinition,
  MetaQualityRating,
  WhatsAppSendLimit,
} from 'modules/graphql';

export const WHATSAPP_SEND_LIMIT_MAPPER: EnumMapper<WhatsAppSendLimit, string> = {
  [WhatsAppSendLimit.Limit100K]: '100,000 messages',
  [WhatsAppSendLimit.Limit10K]: '10,000 messages',
  [WhatsAppSendLimit.Limit1K]: '1,000 messages',
  [WhatsAppSendLimit.Limit250]: '250 messages',
  [WhatsAppSendLimit.Limit50]: '50 messages',
  [WhatsAppSendLimit.LimitNa]: 'N/A',
  [WhatsAppSendLimit.Unlimited]: 'unlimited messages',
};

/** Warning WhatsApp Locales messages */
export const WHATSAPP_LOCALE_STATUS_AND_QUALITY_WARNING_MESSAGE: EnumMapper<
  MetaApprovalStatusDefinition | MetaQualityRating,
  { title: string; description: string }
> = {
  [MetaApprovalStatusDefinition.FirstPaused]: {
    title: 'Paused locale',
    description:
      'At least one locale in this template is paused for the next 3 hours due to negative feedback or low engagement and is at risk of being disabled by Meta.',
  },
  [MetaApprovalStatusDefinition.SecondPaused]: {
    title: 'Paused locale',
    description:
      'At least one locale in this template is paused for the next 6 hours due to negative feedback or low engagement and is at risk of being disabled by Meta.',
  },
  [MetaApprovalStatusDefinition.Disabled]: {
    title: 'Disabled locale',
    description:
      'At least one locale in this template has been disabled due to recurring negative feedback from customers. Messages sent to users with this locale will be skipped.',
  },
  [MetaQualityRating.Low]: {
    title: 'Low quality locale',
    description:
      'At least one locale in this template has received negative feedback or low engagement and is at risk of being paused.',
  },
};
